if (!customElements.get('mkp-wall-preview')) {
  customElements.define('mkp-wall-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.catalog = JSON.parse(this.querySelector('[data-wall-catalog]').textContent);
      this.copy = JSON.parse(this.querySelector('[data-wall-copy]').textContent);
      this.dialog = this.querySelector('dialog');
      this.scope = document.getElementById('MainProduct-' + this.dataset.sectionId);
      this.opener = this.querySelector('[data-wall-open]');
      this.sizeSelect = this.querySelector('[data-wall-size]');
      this.presentationSelect = this.querySelector('[data-wall-presentation]');
      this.sizeSelect.addEventListener('change', () => this.changeSize());
      this.presentationSelect.addEventListener('change', () => this.changePresentation());
      this.opener.addEventListener('click', () => this.open());
      this.querySelector('[data-wall-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => { if (!this.hidden) this.opener.focus(); });
      this.onChange = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      };
      this.scope.addEventListener('change', this.onChange);
      this.observer = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.onChange();
      });
      this.observer.observe(this.scope, {subtree:true, childList:true, attributes:true,
        attributeFilter:['hidden','value','aria-checked','data-mkp-addon-variant-id','data-mkp-presentation-value','data-mkp-variant-eligible']});
      this.onChange();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.scope?.removeEventListener('change', this.onChange);
      cancelAnimationFrame(this.frame);
      clearTimeout(this.pendingTimer);
      this.initialized = false;
    }
    sync() {
      const config = this.scope.querySelector('[data-mkp-frame-config]');
      const data = config?.mkpFramingData;
      if (!data) return;
      const variantId = document.getElementById('product-form-' + this.dataset.sectionId)?.querySelector('[name="id"]')?.value;
      const variant = data?.variants.find(item => String(item.id) === String(variantId));
      if (this.pendingVariant) {
        const root = this.nativeVariantRoot();
        const confirmed = JSON.parse(root?.querySelector('[data-selected-variant]')?.textContent || 'null');
        if (String(variantId) !== this.pendingVariant || String(confirmed?.id) !== this.pendingVariant) return;
        clearTimeout(this.pendingTimer);
        this.pendingVariant = null;
        this.sizeSelect.disabled = false;
        this.presentationSelect.disabled = false;
      }
      const index = data?.options.findIndex(name => name.toLowerCase() === 'size');
      const size = (variant?.options[index] || '').toLowerCase().replace(/×/g,'x').replace(/[\s"'“”″]/g,'');
      const framed = !config.querySelector('[data-mkp-frame-styles]').hidden;
      const style = framed ? config.dataset.mkpPresentationValue : 'Gallery White';
      const active = !config.hidden && config.dataset.mkpVariantEligible !== 'false' && variant;
      this.querySelector('[data-wall-default]').hidden = framed;
      const selected = active ? this.catalog.find(item => item.size === size && item.style === style && item.variantIds.includes(String(variantId))) : null;
      if (this.hidden !== !selected) this.hidden = !selected;
      if (!selected) { this.selected = null; if (this.dialog.open) this.dialog.close(); return; }
      this.syncControls(data, variant, index, framed, style);
      if (selected === this.selected) return;
      this.selected = selected;
      const [width, height] = selected.outside_size_inches;
      const dimensions = this.copy.dimensions.replace('{width}',width).replace('{height}',height);
      this.querySelector('[data-wall-selection]').textContent = `${selected.artwork ? selected.artwork + ' · ' : ''}${variant.options[index]} · ${style} · ${dimensions}`;
      if (this.viewer) this.setModel();
    }
    nativeVariantRoot() {
      return [...this.scope.querySelectorAll('variant-selects')].find(root => root.style.display !== 'none');
    }
    syncControls(data, variant, sizeIndex, framed, style) {
      const choices = data.variants.filter(item =>
        item.options.every((value, index) => index === sizeIndex || value === variant.options[index]) &&
        this.catalog.some(model => model.variantIds.includes(String(item.id))));
      const signature = JSON.stringify(choices.map(item => [item.id, item.options[sizeIndex], item.available]));
      if (signature !== this.sizeSignature) {
        this.sizeSelect.replaceChildren(...choices.map(item => {
          const option = new Option(item.options[sizeIndex], String(item.id));
          option.disabled = !item.available;
          return option;
        }));
        this.sizeSignature = signature;
      }
      this.sizeSelect.value = String(variant.id);
      this.presentationSelect.value = style;
      const price = document.getElementById('price-' + this.dataset.sectionId)?.querySelector('.price__regular .price-item--regular')?.textContent.trim();
      this.querySelector('[data-wall-price]').textContent = price ? this.copy.priceLabel + ' ' + price : '';
    }
    changeSize() {
      const config = this.scope.querySelector('[data-mkp-frame-config]');
      const data = config.mkpFramingData;
      const variant = data.variants.find(item => String(item.id) === this.sizeSelect.value);
      const index = data.options.findIndex(name => name.toLowerCase() === 'size');
      const group = this.nativeVariantRoot()?.querySelector('[data-mkp-option-index="' + index + '"]');
      const radio = [...(group?.querySelectorAll('input[type=radio]') || [])].find(input => input.value === variant?.options[index]);
      const select = group?.querySelector('select');
      if (!variant || (!radio && !select)) { this.sync(); return; }
      if (String(variant.id) === String(this.selected?.variantIds[0])) return;
      this.pendingVariant = String(variant.id);
      this.sizeSelect.disabled = true;
      this.presentationSelect.disabled = true;
      if (this.cameraButton) this.cameraButton.disabled = true;
      this.querySelector('[data-wall-status]').textContent = this.copy.updating;
      clearTimeout(this.pendingTimer);
      this.pendingTimer = setTimeout(() => {
        if (this.pendingVariant) this.querySelector('[data-wall-status]').textContent = this.copy.updateFailed;
      }, 20000);
      if (radio) radio.click();
      else { select.value = variant.options[index]; select.dispatchEvent(new Event('change', {bubbles:true})); }
      this.onChange();
    }
    changePresentation() {
      if (this.pendingVariant) return;
      const config = this.scope.querySelector('[data-mkp-frame-config]');
      const style = this.presentationSelect.value;
      const row = [...config.querySelectorAll('[data-mkp-style]')].find(row => row.dataset.mkpStyle === style);
      if (!row) return;
      config.querySelector('[data-mkp-framed-choice=yes]').click();
      row.click();
      this.sync();
    }
    async open() {
      this.sync();
      if (!this.selected || this.pendingVariant) return;
      this.dialog.showModal();
      const status = this.querySelector('[data-wall-status]');
      status.textContent = this.copy.loading;
      try {
        if (!customElements.get('model-viewer')) await import(this.dataset.viewerUrl);
        if (!this.selected || !this.isConnected || !this.dialog.open) return;
        if (!this.viewer) {
          const viewer = document.createElement('model-viewer');
          this.viewer = viewer;
          for (const [key,value] of Object.entries({ar:'','ar-modes':'webxr scene-viewer quick-look',
            'ar-placement':'wall','ar-scale':'fixed','camera-controls':'','touch-action':'pan-y',
            'camera-orbit':'0deg 90deg auto','shadow-intensity':'0',exposure:'1','tone-mapping':'neutral'})) viewer.setAttribute(key,value);
          const camera = document.createElement('button');
          this.cameraButton = camera;
          camera.type = 'button'; camera.className = 'button mkp-wall-camera';
          camera.textContent = this.copy.camera; camera.disabled = true; camera.hidden = true;
          viewer.style.setProperty('--ar-button-display', 'none');
          camera.addEventListener('click', () => viewer.activateAR().catch(() => { status.textContent = this.copy.failed; }));
          viewer.addEventListener('load', event => {
            if (!this.selected || new URL(event.detail.url,location.href).href !== new URL(this.selected.glb,location.href).href) return;
            if (this.pendingVariant) return;
            camera.disabled = !!this.pendingVariant;
            camera.hidden = !viewer.canActivateAR;
            status.textContent = viewer.canActivateAR ? this.copy.ready : this.copy.desktop;
          });
          viewer.addEventListener('error', () => {camera.disabled = true; status.textContent = this.copy.failed;});
          viewer.addEventListener('ar-status', event => {if(event.detail.status === 'failed') status.textContent = this.copy.failed;});
          this.querySelector('[data-wall-viewer]').append(viewer, camera);
        }
        this.setModel();
      } catch { status.textContent = this.copy.failed; }
    }
    setModel() {
      const current = this.selected;
      if (!current || !this.viewer) return;
      if (this.viewer.getAttribute('src') === current.glb && this.viewer.loaded) {
        this.cameraButton.disabled = !!this.pendingVariant;
        this.querySelector('[data-wall-status]').textContent = this.viewer.canActivateAR ? this.copy.ready : this.copy.desktop;
        return;
      }
      this.cameraButton.disabled = true;
      this.querySelector('[data-wall-status]').textContent = this.copy.loading;
      this.viewer.setAttribute('ios-src', current.usdz);
      this.viewer.setAttribute('src', current.glb);
      this.viewer.setAttribute('alt', `${this.dataset.productTitle} · ${current.artwork || ''} · ${current.size} · ${current.style}`);
    }
  });
}
